import { withProps } from 'recompose'

const withReduxFormQuantity = withProps(({
  step = 1,
  value,
  minValue = -Infinity,
  maxValue = Infinity,
  onChange
}) => ({
  increaseHandler: () => onChange(value + step > maxValue ? maxValue : value + step),
  decreaseHandler: () => onChange(value - step < minValue ? minValue : value - step),
  onChange: ({ value }) => onChange(value)
}))

export default withReduxFormQuantity
